import { useState, useEffect } from "react";
import { XIcon } from "@heroicons/react/outline";

const StatusModal = ({ isOpen, onClose, link, onSubmit, loading }) => {
  const [status, setStatus] = useState(true);

  useEffect(() => {
    if (link) {
      setStatus(link.is_active);
    }
  }, [link]);

  if (!isOpen || !link) return null;

  const handleSubmit = () => {
    onSubmit({
      id: link.id,
      is_active: status,
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="w-full max-w-md bg-slate-900 border border-white/10 rounded-xl shadow-xl">
        
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
          <h2 className="text-lg font-semibold text-white">
            {link.name}
          </h2>

          <button onClick={onClose} className="text-slate-400 hover:text-white">
            <XIcon className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5 space-y-5">

          {/* Status */}
          <div>
            <label className="block text-sm text-slate-300 mb-2">
              {!status ? 'Change Status to Active' : 'Change Status to Inactive'}
            </label>

            {/* <div className="flex items-center gap-6">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  checked={status === true}
                  onChange={() => setStatus(true)}
                  className="accent-pink-600"
                />
                <span className="text-sm text-slate-300">Active</span>
              </label>

              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  checked={status === false}
                  onChange={() => setStatus(false)}
                  className="accent-pink-600"
                />
                <span className="text-sm text-slate-300">Inactive</span>
              </label>
            </div> */}
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 px-6 py-4 border-t border-white/10">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm rounded-lg text-slate-300 hover:bg-slate-800"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className={`px-4 py-2 text-sm rounded-lg text-white ${
              loading
                ? "bg-pink-400"
                : "bg-pink-600 hover:bg-pink-700"
            }`}
          >
            {loading ? "Saving..." : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusModal;